import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class ClassGroupIndexRoute extends Route 
{
	@service router;
	
	redirect(model)
	{
		this.router.transitionTo('event.class-group.results',model);
	}
}